import { Box, Grid, Typography } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';

import { DisplayCurrency } from 'src/components';
import { DEFAULT_BORDER } from 'src/constants';
import { CommissionItemsProps } from 'src/types/commission-statement';
import { formatDate } from 'src/utils/utils';

const CommissionsItemsTable = ({
    commissionItems,
    commissionType,
    commissionTypeHeading,
    currency,
}: CommissionItemsProps) => {
    const columns: GridColDef[] = [
        { field: 'merchantId', headerName: 'ID', flex: 0.0 },
        {
            field: 'merchant',
            headerName: 'Merchant',
            minWidth: 120,
            flex: 0.3,
        },
        {
            field: 'serviceActivationDate',
            headerName: 'Service Activation Date',
            minWidth: 120,
            flex: 0.2,
            renderCell: (params) => {
                return <>{formatDate({ date: new Date(params.row.serviceActivationDate) })}</>;
            },
        },
        {
            field: 'setupAndAccessory',
            headerName: 'Setup And Accessory',
            flex: 0.2,
            renderCell: (params) => {
                return (
                    <DisplayCurrency
                        centsAmount={params.row.setupAndAccessory}
                        usersCurrency={currency}
                    />
                );
            },
        },
        {
            field: commissionType,
            headerName: commissionTypeHeading,
            flex: 0.15,
            renderCell: (params) => {
                return (
                    <DisplayCurrency centsAmount={params.row.monthly} usersCurrency={currency} />
                );
            },
        },
        {
            field: 'totalCommission',
            headerName: 'Commission',
            flex: 0.15,
            renderCell: (params) => {
                return (
                    <DisplayCurrency
                        centsAmount={params.row.totalCommission}
                        usersCurrency={currency}
                    />
                );
            },
        },
    ];

    if (!commissionItems || commissionItems?.length < 1) {
        return null;
    }

    return (
        <>
            <Grid
                item
                xs={12}
                sx={{
                    ...DEFAULT_BORDER,
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                    padding: '32px 24px',
                }}
                gap={'18px'}
                container
            >
                {/* Heading */}
                <Grid item xs={12}>
                    <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                        <Typography variant="h2">Commission Items</Typography>
                    </Box>
                </Grid>
                {commissionItems.map((commissionItem) => {
                    return (
                        <Box
                            key={commissionItem?.legalName}
                            width={'100%'}
                            display={'flex'}
                            flexDirection={'column'}
                            gap={'13px'}
                        >
                            <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                                <Typography variant="h2">
                                    {`${commissionItem?.legalName}${
                                        commissionItem.partnerOfPartner !== null ? ' - Partner' : ''
                                    }`}
                                </Typography>
                            </Box>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <DataGridPro
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: {
                                                id: false,
                                            },
                                        },
                                    }}
                                    rows={commissionItem?.commissionItems.map((item) => {
                                        return item.commissionItem;
                                    })}
                                    getRowId={(row) => {
                                        return `${row.merchantId}-${row.serviceActivationDate}`;
                                    }}
                                    columns={columns}
                                    disableColumnFilter
                                    disableColumnMenu
                                    disableColumnSelector
                                    disableRowSelectionOnClick
                                    hideFooterPagination
                                    hideFooterRowCount
                                    getRowHeight={() => {
                                        return 'auto';
                                    }}
                                />
                            </div>
                        </Box>
                    );
                })}
            </Grid>
        </>
    );
};

export default CommissionsItemsTable;
